import { Card, CardContent, Grid } from '@mui/material';
import { DiscussionListFilter } from 'generated/CoreApi_v1';
import React, { useEffect, useRef } from 'react';
import { useSearchParams } from "react-router";
import { isOfTypeLpEnrollmentViewAboutTabs, LpEnrollmentViewAboutTabs } from 'views/lms/student/EnrollmentView/LearnPath/LpEnrollmentViewAbout';
import PreviewNotice from 'views/lms/student/EnrollmentView/Shared/PreviewNotice';
import { TrainingViewRightPanel } from 'views/lms/student/TrainingView/TrainingViewRightPanel';
import { useEnrollmentViewContext } from '..';
import { EnrollmentViewContainer } from "../Shared/EnrollmentViewContainer";
import { LpEnrollmentViewHeader } from "./LpEnrollmentViewHeader";
import { LpEnrollmentViewSteps } from "./LpEnrollmentViewSteps";

/////////////////////////////////////////////////////////////////////////////////////

export const LpEnrollmentView: React.FC = () => {

    const { enrollment, openRightPanel } = useEnrollmentViewContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const initialAboutTab = useRef<LpEnrollmentViewAboutTabs | undefined>(undefined);
    const initialDiscussionFilter = useRef<DiscussionListFilter>(DiscussionListFilter.All);

    /*************************************************************************************
     * Analisa QueryString
     * "at" = Overview About Tab
     * "df" = Discussion Filter
    *************************************************************************************/
    // Este check ficou fora o useEffect propositalmente, para que não seja necessário criar um estado.
    if (searchParams.has("at")) {
        const at = searchParams.get("at");
        if (at && isOfTypeLpEnrollmentViewAboutTabs(at)) initialAboutTab.current = searchParams.get("at") as LpEnrollmentViewAboutTabs;
    }
    if (searchParams.has("df")) {
        const df = searchParams.get("df");
        if (df) {
            const filter: DiscussionListFilter = (DiscussionListFilter[df as any]) as any;
            if (filter) initialDiscussionFilter.current = filter;
        }
    }

    useEffect(() => {
        if (searchParams.size > 0) setSearchParams("");
    }, []);

    ///
    return (
        <>
            <LpEnrollmentViewHeader
                initialAboutTab={initialAboutTab.current}
                initialDiscussionFilter={initialDiscussionFilter.current}
            />
            {enrollment.isPreview && <PreviewNotice />}
            <EnrollmentViewContainer
                content={
                    <Grid container direction="row" width="100%">
                        <Grid size={{ xs: 12 }}>
                            <LpEnrollmentViewSteps />
                        </Grid>
                    </Grid>
                }
                rightPanel={
                    <Card elevation={openRightPanel ? 0 : undefined}>
                        <CardContent sx={openRightPanel ? { p: 0 } : {}}>
                            <TrainingViewRightPanel trainingId={enrollment.trainingId} />
                        </CardContent>
                    </Card>
                } />
        </>
    );
};
